import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore, useUserOrganization } from '@/store/auth/auth.store';
import NavigationInitializer from '@/libs/useNavigate';

const AdminProtectRoute = () => {
  const { currentOrganization } = useUserOrganization();
  const user = useAuthStore(state => state.user);
  // Check if user is logged in and has admin role
  if (!user || currentOrganization?.role?.toLowerCase() !== 'admin') {
    return <Navigate to="/404" replace />;
  }
  return <Outlet />;
};

export default AdminProtectRoute;

const SuperAdminProtectRoute = () => {
  const user = useAuthStore(state => state.user);
  // Check if user is logged in and has superadmin role
  if (user?.role?.toLowerCase() !== 'superadmin') {
    return <Navigate to="/404" replace />;
  }
  return (
    <>
      <Outlet />
      <NavigationInitializer />
    </>
  );
};

export { SuperAdminProtectRoute };
